import { lazy } from "react";

// project import
// import GuestGuard from 'utils/route-guard/GuestGuard';
// import CommonLayout from 'layout/CommonLayout';
import Loadable from "components/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

// render
const Users = Loadable(lazy(() => import("pages/shops/users")));
const Stores = Loadable(lazy(() => import("pages/shops/adminStores")));
const Dashboard = Loadable(lazy(() => import("pages/shops/dashboard")));
const Notifications = Loadable(lazy(() => import("pages/notification")));
const Errors = Loadable(lazy(() => import("pages/error-reporting")));

const AdminRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "admin",
      children: [
        {
          path: "",
          element: <Dashboard />,
        },
        {
          path: "users",
          element: <Users />,
        },
        {
          path: "stores",
          element: <Stores />,
        },
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "notifications",
          element: <Notifications />,
        },
        {
          path: "error-reporting",
          element: <Errors />,
        },
      ],
    },
  ],
};

export default AdminRoutes;
